module.exports = __webpack_public_path__ + "static/img/bottomBakgroup.86363adc.png";